export default (setDragged: Function, draggedFromFormId: string, draggedFromIndex: number) => {
  setDragged({
    draggedFromFormId: draggedFromFormId,
    draggedFromIndex: draggedFromIndex,
  });
}